import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Form, Row, Col, Button } from 'react-bootstrap';
import { FaDownload, FaFileAlt } from 'react-icons/fa';
import moment from 'moment';
import api from '../services/api';
import { getMediaUrl } from '../services/api';

const Downloads = () => {
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryFilter, setCategoryFilter] = useState('');

  useEffect(() => {
    loadDownloads();
  }, [categoryFilter]);

  const loadDownloads = async () => {
    try {
      const params = categoryFilter ? { category: categoryFilter } : {};
      const response = await api.get('/downloads/', { params });
      setDownloads(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading downloads:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (id) => {
    try {
      await api.post(`/downloads/${id}/download/`);
    } catch (error) {
      console.error('Error tracking download:', error);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <h1 className="page-title mb-4">Downloads</h1>
      
      <Row className="mb-4">
        <Col md={4}>
          <Form.Select value={categoryFilter} onChange={(e) => setCategoryFilter(e.target.value)}>
            <option value="">All Categories</option>
            <option value="forms">Forms</option>
            <option value="reports">Reports</option>
            <option value="acts">Acts & Rules</option>
            <option value="policies">Policies</option>
            <option value="budgets">Budgets</option>
            <option value="other">Other</option>
          </Form.Select>
        </Col>
      </Row>

      <div className="table-responsive">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Title</th>
              <th>Category</th>
              <th>Size</th>
              <th>Published</th>
              <th>Downloads</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {downloads.map(download => (
              <tr key={download.id}>
                <td>
                  <FaFileAlt className="me-2 text-primary" />
                  {download.title}
                </td>
                <td>
                  <Badge bg="secondary">{download.category}</Badge>
                </td>
                <td>{download.file_size}</td>
                <td>{moment(download.published_date).format('MMM DD, YYYY')}</td>
                <td>{download.download_count}</td>
                <td>
                  <Button 
                    variant="success" 
                    size="sm"
                    href={getMediaUrl(download.file)}
                    target="_blank"
                    onClick={() => handleDownload(download.id)}
                  >
                    <FaDownload className="me-1" />
                    Download
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default Downloads;
